import React from 'react';
import ReactPlayer from 'react-player';
import { useHistory } from "react-router-dom";
import { useStore } from '../utils/score';
import { useStoreAnswered } from '../utils/answeredQuestions';
import isSingle from './game/Single';


function Video() {

        const answeredQuestions = useStoreAnswered(state => state.answeredQuestions)
        const videoUrl = useStore(state => state.videoUrl)
        const textOdpoved = useStore(state => state.textOdpoved)
        let history = useHistory();

        const goToPreviousPath = () => {
            history.goBack()
        }


        function returnToGames() {

       

            const goToPreviousPath = () => {
            history.goBack()


            
    }
        };

    return(

        <div className="video-main">
             <div>
            <h4>{textOdpoved}</h4>
             </div>

                <div className="video-container">
                <br></br>
            <br></br>
                    <ReactPlayer className="video" url={videoUrl} />
                </div>
            
            <div className="btn-container-video">
                <p>{answeredQuestions}</p>
                <button className='btn btn-video' onClick={goToPreviousPath}><h4>Next</h4></button>
                {/* <button className='btn btn-video' onClick={returnToGames}><h4>Next</h4></button> */}
            </div>
        </div>
        

    );
}

export default Video;

